module.exports = __webpack_public_path__ + "static/media/family-planning.c495f5bf.svg";